/*
 * Filename: d:\projects\AutoFiFront\src\Content\Car\CarElement\CarElement.type.ts
 * Path: d:\projects\AutoFiFront
 * Created Date: Thursday, February 2nd 2023, 9:50:31 am
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import Config from "Config/Config";

class CarCost {
  public carCost = 0;
  public CustomText = "";

  public fromJson(jsonObj: any) {
    this.carCost = parseInt(jsonObj.SellPrice);
    this.CustomText = jsonObj.CustomText ?? "";
  }
}

class IconSubSection {
  IconSubSection = "";

  public fromJson(jsonObj: any) {
    this.IconSubSection = jsonObj.SubSection;
  }
}

class CarInfo {
  public Status = "";
  public Brand = "";
  public Model = "";
  public Version = "";
  public Mileage = 0;
  public CirculationDate: Date = new Date();
  public Gears = "";
  public Energy = "";
  public SellPrice = 0;
  public Color = "";
  public Link = "";
  public Comments = "";
  public Fav = false;
  public CarType: {
    Abreviation: string;
    Name: string;
    // id: string;
  } = {
    Abreviation: "",
    Name: "",
    // id: "",
  };

  public fromJson(jsonObj: any) {
    this.Status = jsonObj.Status;
    this.Brand = jsonObj.Brand;
    this.Model = jsonObj.Model;
    this.Version = jsonObj.Version;
    this.Mileage = parseInt(jsonObj.Mileage);
    this.CirculationDate = new Date(jsonObj.CirculationDate);
    this.Gears = jsonObj.Gears;
    this.Comments = jsonObj.Comments;
    this.SellPrice = jsonObj.SellPrice;
    this.Color = jsonObj.Color ?? "N/A";
    this.Link = jsonObj.Link;
    this.Energy = jsonObj.Energy?.Name ?? "other";
    this.Fav = jsonObj.Favorites?.length > 0 ? true : false;
    this.CarType = jsonObj.CarType;
  }
}

class CarImg {
  public url: string = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GET_PICTURE}`;
  public status = "";
  public subSection = "";

  public fromJson(jsonObj: any) {
    this.url = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.GET_PICTURE}${jsonObj.id}`;
    this.status = jsonObj.Status;
    this.subSection = jsonObj.SubSection;
  }
}

export class SingleCarFormat {
  public id = "";
  public carCost: CarCost = new CarCost();
  public carInfo: CarInfo = new CarInfo();
  public iconSubSection: IconSubSection = new IconSubSection();
  public carImg: CarImg = new CarImg();

  public fromJson(jsonObj: any): void {
    this.id = jsonObj.id;
    this.carCost.fromJson(jsonObj);
    this.iconSubSection.fromJson(jsonObj);
    this.carInfo.fromJson(jsonObj);
    this.carImg.fromJson(jsonObj);
  }
}
